import { useMemo } from "react";
import { valueDropdownData } from "../../config/apiPageData";

export const useEndpointFields = endpointName => {
    const result = useMemo(() => {
        const entry = valueDropdownData.find(item => item.endPoint === endpointName);
        if (!entry) {
            return { inputFields: [], outputFields: [] };
        }

        const inputFields =
            entry.inputFields?.map(field => ({
                name: field.value,
                value: field.value,
                isExtraField: true
            })) || [];

        const outputFields =
            entry.outputFields?.map(field => ({
                name: field.value,
                value: field.value,
                isReturnField: true
            })) || [];

        return { inputFields, outputFields };
    }, [endpointName]);

    return result;
};
